import { createSlice } from '@reduxjs/toolkit'

import { RootState } from '../../store/store'

export enum VisualizeMode {
  Admin,
  Accountant,
  Company,
  Reseller,
}

export interface VisualizationState {
  value: number
}

export const visualizationModeSlice = createSlice({
  name: 'visualizationMode',
  initialState: {
    value: VisualizeMode.Admin,
  },
  reducers: {
    setAccountant: (state) => {
      state.value = VisualizeMode.Accountant
    },
    setCompany: (state) => {
      state.value = VisualizeMode.Company
    },
    setReseller: (state) => {
      state.value = VisualizeMode.Reseller
    },
    setAdmin: (state) => {
      state.value = VisualizeMode.Admin
    },
  },
})

export const { setAccountant, setAdmin, setCompany, setReseller } =
  visualizationModeSlice.actions
export const selectVisualization = (state: RootState): VisualizeMode =>
  state.visualizationMode.value
export default visualizationModeSlice.reducer
